export default {
    defaultErrorMessage: 'An error occurred!',

    logInErrorText: {
        invalidCredentials: 'Wrong username or password',
        inactiveUser:
            'The user with provided email is inactive. Check your email for account-activaction or try to reset your password.',
        default: 'Was not able to authenticate.',
    },
    registerErrorText: {
        passwordTooShort: 'Password has to be atleast 8 digits long.',
        emailTaken:
            'Email is already in use. If you used your school email, this might happen because you had a user before the platform was upgraded (at higheredtalent.org).',
        default: 'Was not able to create a user.',
    },
    invalidTokenText: {
        default: 'Your token is invalid or has expired.',
    },
    passwordErrorText: {
        passwordTooShort: 'Password has to be atleast 8 digits long.',
        requireNonAlphanumeric:
            'The password must contain at least one special character.',
        requireLowerCase:
            'The password must contain at least one lowercase letter.',
        requireUpperCase:
            'The password must contain at least one uppercase letter.',
        requireUniqueChars:
            'The password must contain at least 6 different characters',
        default: 'Was not able to change password',
    },
    recoverErrorText: {
        userNotFound: 'The user does not exist! Please contact support.',
        userAlreadyActive:
            'The user is already activated!\nPlease try to log in.',
        emailAlreadyInUse:
            'The provided email is already in use.\nTry a different email or a different social login.',
        default: 'Was not able to activate account.\nPlease try again later.',
    },
    socialAuthErrorText: {
        errorTitle: 'Could not log in with {provider}',
        invalidProviderGoogle:
            'The user with the provided email is not connected with Google. Please try to for example log in with LinkedIn, Facebook, or email.',
        invalidProviderFacebook:
            'The user with the provided email is not connected with Facebook. Please try to for example log in with Google, LinkedIn, or email.',
        invalidProviderLinkedIn:
            'The user with the provided email is not connected with LinkedIn. Please try to for example log in with Google, Facebook, or email.',
        invalidProviderWeChat:
            'The user with the provided email is not connected with WeChat. Please try to for example log in with Google, Facebook, or email.',
    },

    uniConnErrorText: {
        emailNotAvailable:
            'The email you provided is already in use. This might be because you had a user before the platform was upgraded (at higheredtalent.org). Please contact support.',
        invalidEmailDomain:
            'The provided email-domain does not match provided university. Please choose the correct university.',
        existingConnection:
            'The user is already connected to the provided university',

        default: 'Was not able to initiate verification.',
    },

    spotlightErrors: {
        userUpdate: {
            emailAlreadyInUse: 'Email is already in use',
            default: 'Was not able to update',
        },
    },
};
